import { FilterInstance, FilterKind } from '../types';
import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import { TimeUnit } from '@nirvana/shared/constants';
import { isEmpty } from '@nirvana/shared/basic-types/object';

function filterInFrontend<ColKeys extends string, Row extends Record<string, any>>(
  filter: FilterInstance<ColKeys>,
  row: Row
): boolean {
  const colKey = Object.keys(filter)[0] as ColKeys;
  const rowDateAdded = new Date(row[colKey]);

  let maxTime = new Date();
  let minTime = new Date();

  const timeRange = filter[colKey].timeRange;
  if (isEmpty(timeRange)) {
    return true;
  }

  if (timeRange.kind === TimeRangeKind.ABSOLUTE_TIME_RANGE) {
    minTime = new Date(timeRange.absolute.fromTimestamp);
    maxTime = new Date(timeRange.absolute.toTimestamp);
  } else if (timeRange.kind === TimeRangeKind.RELATIVE_TIME_RANGE) {
    maxTime = new Date();
    minTime = new Date(maxTime.getTime() - timeRange.relative.lastNumDays * TimeUnit.DAY);
  } else if (timeRange.kind === TimeRangeKind.ALL_TO_DATE) {
    minTime = new Date(0);
    maxTime = new Date();
  }

  return minTime.getTime() <= rowDateAdded.getTime() && rowDateAdded.getTime() <= maxTime.getTime();
}

export const timeRangeFilter: FilterKind = {
  filterInFrontend,
};
